<script lang="ts" setup>
const { openInvoiceCommentPopup: { data: payload, close: closePopup } } = useGlobalOpeners()
</script>

<template>
  <ThePopup v-if="payload" width="1024px" :show="Boolean(payload)" :title="`Kommentare zu Rechnung ${payload.invoiceId ?? 'N/A'}`" @close="closePopup">
    <CommentList :id="payload.id" type="Invoice" />
  </ThePopup>
</template>
